<template>
  <section class="sequence-section">
    <div v-if="steps.length" class="step-list">
      <article class="step-card" v-for="step in steps" :key="step.id">
        <div class="step-card__header">
          <div>
            <span class="step-title">{{ step.template?.name || '-' }}</span>
            <div class="sequence-muted">{{ step.template?.type?.name || 'Document' }}</div>
          </div>
          <div class="step-statuses">
            <a-tag :color="step.is_required ? '#f59e0b' : '#6b7280'" class="m-0">
              {{ step.is_required ? 'Required' : 'Optional' }}
            </a-tag>
            <a-tag :color="adminStepStatusColor(step)" class="m-0">
              {{ adminStepStatusTitle(step) }}
            </a-tag>
          </div>
        </div>

        <div class="step-card__actions" v-if="canManageDocuments">
          <a-button v-if="!step.document" type="primary" @click="$emit('open-document-modal', step)">
            {{ step.is_required ? 'Attach required document' : 'Attach document' }}
          </a-button>
          <a-button v-else ghost type="primary" @click="$emit('open-document-view', step.document)">
            Review attached document
          </a-button>
        </div>
      </article>
    </div>
    <a-alert v-else type="info" message="No admin tasks were required for this sequence." />

    <p v-if="showValidation" class="validation-copy">Attach required admin documents to continue.</p>
  </section>
</template>

<script>
import { Alert, Button, Tag } from 'ant-design-vue'
import { getAdminStepStatusColor, getAdminStepStatusTitle } from './sequence-review.helpers'

export default {
  name: 'SequenceReviewAdminTasks',
  components: {
    'a-alert': Alert,
    'a-button': Button,
    'a-tag': Tag
  },
  props: {
    steps: {
      type: Array,
      default: () => []
    },
    canManageDocuments: {
      type: Boolean,
      default: false
    },
    showValidation: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    adminStepStatusTitle: getAdminStepStatusTitle,
    adminStepStatusColor: getAdminStepStatusColor
  }
}
</script>

<style scoped>
.sequence-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.step-list {
  display: grid;
  grid-auto-rows: max-content;
  gap: 12px;
  max-height: 360px;
  overflow: auto;
}

.step-card {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 14px;
  border: 1px solid var(--border-color-base);
  border-radius: 8px;
}

.step-card__header,
.step-card__actions {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: flex-start;
}

.step-card__actions {
  justify-content: flex-end;
  flex-wrap: wrap;
}

.step-title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
}

.step-statuses {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.sequence-muted {
  color: #6b7280;
  font-size: 12px;
}

.validation-copy {
  color: #ef4444;
}

@media screen and (max-width: 640px) {
  .step-card__header,
  .step-card__actions {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>
